import { FC } from "react";

import { BaseProps } from "capitalrx-components-2.0/lib/BaseProps";
import { AccessibilityProps } from "capitalrx-components-2.0/lib/AccessibilityProps";
import { getHtmlPropsFromBaseProps } from "capitalrx-components-2.0/lib/utilities";
import { createComponentStyleHook } from "../../tokens";

import tokenStyles from "./styles.module.css";
import legacyStyles from "./legacy/styles.module.scss";

const useStyles = createComponentStyleHook<HorizontalLineProps>({
  legacyStyles,
  tokenStyles,
  componentTokens: "horizontal_line",
});

export interface HorizontalLineProps extends BaseProps, AccessibilityProps { }

export const HorizontalLine: FC<HorizontalLineProps> = (props) => {
  const { className, role = "separator" } = props;
  const { mode, styles, StyleModeBoundary } = useStyles(props);

  const baseHtmlProps = getHtmlPropsFromBaseProps(props, {
    className: [styles.HorizontalLine, className],
    testIdPrefix: "horizontal_line",
  });

  return <StyleModeBoundary mode={mode}>
    <hr {...baseHtmlProps} role={role} />
  </StyleModeBoundary>
};
